import { logo } from '@novachat/design-tokens';

/** The NovaChat logo (white mark on its own orange), drawn from the shared geometry. */
export function Logo({ size = 34, className = '' }: { size?: number; className?: string }) {
  // The artwork keeps the mark at about half the square; a little larger reads better this small.
  const width = size * 0.62;
  return (
    <span
      className={`nc-cta grid flex-none place-items-center ${className}`}
      style={{ width: size, height: size, borderRadius: size * 0.3, background: logo.color }}
      aria-hidden="true"
    >
      <svg width={width} height={(width * logo.height) / logo.width} viewBox={`0 0 ${logo.width} ${logo.height}`} fill="#fff">
        <path d={logo.mark} />
      </svg>
    </span>
  );
}

export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`font-heading font-bold ${className}`}>
      Nova<span className="text-brand-400">Chat</span>
    </span>
  );
}
